import Vue from 'vue';
import VueRouter from 'vue-router'
import Notifications from 'vue-notification'
//import App from './App.vue';
import HelloWorld from './components/HelloWorld.vue';
import Login from './components/Login.vue';
import Home from './components/Home.vue';
import Guide from './components/Guide.vue';
import RegisteredObject from './components/RegisteredObject.vue';
import BootstrapVue from 'bootstrap-vue'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

//import './custom.scss'

Vue.use(VueRouter)
Vue.use(BootstrapVue)
Vue.use(Notifications)
Vue.config.productionTip = false;
//const NotFound = { template: '<p>�������� �� �������</p>' }
//const Home = { template: '<p>�������</p>' }
//const About = { template: '<p>� ���</p>' }

const routes = [
    { path: '/', component: Login },
    { path: '/Login', component: Login },
    { path: '/Home', component: Home },
    { path: '/RegisteredObject/:uid/:clue', component: RegisteredObject },
    { path: '/RegisteredObject', component: RegisteredObject },
    { path: '/TestRO', component: RegisteredObject },
    { path: '/HelloWorld', component: HelloWorld },
    { path: '/Guide', component: Guide }

]

const router = new VueRouter({
    routes 
})

window.Office.initialize = () => {
    
};

new Vue({
    router
    //,render: h => h(Guide)
}).$mount('#app');

export default router